import client from 'api/client';
import { NavItemType } from 'types/menu';

const t = () => `/${Date.now()}`;

/** Obtiene el menú filtrado por los permisos del usuario autenticado */
export const menuService = {
  getUserMenu: (): Promise<NavItemType[]> =>
    client.post(`/menu${t()}`).then((r) => r.data.data),
};
